import { Component, Input, OnInit } from '@angular/core';

import { Modal } from 'bootstrap';

import { Data2Service } from 'src/app/common/data2.service';
import { DateService } from 'src/app/common/date.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { toMajorUnits, toMinorUnits } from 'src/app/_utils/money.util';

@Component({
	selector: 'app-drivers-rate-set',
	templateUrl: './drivers-rate-set.component.html',
	styleUrls: ['./drivers-rate-set.component.css'],
})
export class DriversRateSetComponent implements OnInit {
	@Input() driver;
	readonly periodTypeRate = 1;
	readonly periodTypeMonthly = 2;
	data = {
		id: null,
		driver: null,
		dateFrom: null,
		dateTo: null,
		workRate: null,
		breakRate: null,
		otherRate: null,
		periodType: 1,
		monthlyAmount: null,
	};
	error = {
		dateRange: false,
	};
	tableRows = [
		{ id: 'dateFrom', name: 'Data od' },
		{ id: 'dateTo', name: 'Data do' },
		{ id: 'typ', name: 'Typ' },
		{ id: 'workRate', name: 'Jezdna' },
		{ id: 'breakRate', name: 'Leżona' },
		{ id: 'otherRate', name: 'Inna' },
		{ id: 'monthlyAmount', name: 'Kwota miesięczna' },
	];
	rates: Array<any> = [];
	tableElements: Array<any> = [];
	isItemBefore = false;
	isItemAfter = false;

	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
		private readonly loader: LoaderService,
		private readonly date: DateService,
	) {}

	ngOnInit(): void {
		this.loadData();
	}

	private loadData() {
		this.loader.show();
		this.api.get(`/driver/driverRate/?driver=${this.driver}`, (result, error) => {
			this.rates = result.data ?? [];
			this.tableElements = this.rates.map((rate) => this.toTableElement(rate));
		});
	}

	private toTableElement(rate) {
		const isMonthly = Number(rate.periodType) === this.periodTypeMonthly;
		return {
			id: rate.id,
			dateFrom: rate.dateFrom,
			dateTo: rate.dateTo,
			typ: isMonthly ? 'Wypłata miesięczna' : 'Stawka',
			workRate: isMonthly ? '—' : rate.workRate,
			breakRate: isMonthly ? '—' : rate.breakRate,
			otherRate: isMonthly ? '—' : rate.otherRate,
			monthlyAmount: isMonthly ? this.formatPln(rate.monthlyAmount) : '—',
		};
	}

	private formatPln(grosze) {
		const major = toMajorUnits(grosze);
		if (major === null) {
			return '—';
		}
		return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(major);
	}

	submit() {
		const periodType = Number(this.data.periodType) || this.periodTypeRate;
		if (periodType !== this.periodTypeRate && periodType !== this.periodTypeMonthly) {
			this.infobox.error('Nieprawidłowy typ okresu.');
			return;
		}

		const payload: any = { ...this.data, periodType };

		if (periodType === this.periodTypeMonthly) {
			const amount = Number(this.data.monthlyAmount);
			if (!Number.isFinite(amount) || amount <= 0) {
				this.infobox.error('Podaj dodatnią kwotę miesięczną (PLN).');
				return;
			}
			payload.monthlyAmount = toMinorUnits(this.data.monthlyAmount);
			payload.workRate = null;
			payload.breakRate = null;
			payload.otherRate = null;
		} else {
			payload.monthlyAmount = null;
		}

		if (!this.data.id) {
			this.api.post(`/driver/driverRate/`, payload, (result, error) => {
				if (error) {
					return;
				}
				this.loadData();
			});
		} else {
			this.api.put(`/driver/driverRate/${this.data.id}/`, payload, (result, error) => {
				if (error) {
					return;
				}
				this.infobox.success('Zapisano');
				this.loadData();
			});
		}
		this.dialogClose();
	}

	openModal() {
		this.data = {
			id: null,
			driver: this.driver,
			dateFrom: this.date.now().date,
			dateTo: null,
			workRate: null,
			breakRate: null,
			otherRate: null,
			periodType: this.periodTypeRate,
			monthlyAmount: null,
		};
		this.isItemAfter = false;
		this.isItemBefore = this.rates.length > 0 ? true : false;
		if (this.isItemBefore) {
			const lastOwner = this.rates[this.rates.length - 1];
			if (!lastOwner.dateTo) {
				this.infobox.error('Uzupełnij datę końcową');
				return;
			}
			this.data.dateFrom = this.date.addDays(1, lastOwner.dateTo);
		}
		new Modal(document.getElementById('rateSetModal')).show();
	}

	dialogClose() {
		const modal = Modal.getInstance(document.getElementById('rateSetModal'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	setRate(row) {
		const raw = this.rates.find((obj) => obj.id == row.id);
		const positionInArray = this.rates.indexOf(raw);
		this.data = {
			...raw,
			periodType: Number(raw.periodType) || this.periodTypeRate,
			monthlyAmount:
				raw.monthlyAmount !== null && raw.monthlyAmount !== undefined ? toMajorUnits(raw.monthlyAmount) : null,
		};
		this.isItemBefore = positionInArray === 0 ? false : true;
		this.isItemAfter = positionInArray === this.rates.length - 1 ? false : true;
		new Modal(document.getElementById('rateSetModal')).show();
	}
}
